import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef, useCallback, useId, useState } from 'react';
import { Message } from '../../primitives/internal/Message/index.js';
import { Container } from '../../primitives/TextInput/components/Container.js';
import { Label } from '../../primitives/TextInput/components/Label.js';
import { Textarea } from '../../primitives/TextInput/components/Textarea.js';
import { Wrapper } from '../../primitives/TextInput/components/Wrapper.js';
export const Area = /*#__PURE__*/_styled(forwardRef(function Area({
  id: propsId,
  disabled,
  visuallyFocused,
  label,
  name,
  value,
  className,
  fullWidth,
  placeholder = ' ',
  message,
  onFocus,
  onBlur,
  ...restProps
}, ref) {
  const autoId = useId();
  const id = propsId || autoId;
  const [focused, setFocused] = useState(false);
  const handleFocus = useCallback(event => {
    if (onFocus) {
      onFocus(event);
    }
    setFocused(true);
  }, [onFocus]);
  const handleBlur = useCallback(event => {
    if (onBlur) {
      onBlur(event);
    }
    setFocused(false);
  }, [onBlur]);
  return _jsxs(Wrapper, {
    ref: ref,
    fullWidth: fullWidth,
    children: [_jsxs(Container, {
      className: className,
      focused: focused || !!visuallyFocused,
      disabled: disabled,
      children: [_jsx(Textarea, {
        ...restProps,
        disabled: disabled,
        name: name,
        placeholder: placeholder,
        value: value,
        onFocus: handleFocus,
        onBlur: handleBlur,
        "aria-describedby": message ? `${id}-message` : undefined
      }), placeholder === ' ' && _jsx(Label, {
        tabIndex: -1,
        "data-testid": "label",
        disabled: disabled,
        htmlFor: id,
        children: label
      })]
    }), message && _jsx(Message, {
      "data-testid": "message",
      id: `${id}-message`,
      children: message
    })]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e1vdsy1t0"
} : {
  target: "e1vdsy1t0",
  label: "Area"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");